import { render, staticRenderFns } from "./IndustryInfo.vue?vue&type=template&id=f39b1844&scoped=true"
import script from "./IndustryInfo.vue?vue&type=script&lang=js"
export * from "./IndustryInfo.vue?vue&type=script&lang=js"
import style0 from "./IndustryInfo.vue?vue&type=style&index=0&id=f39b1844&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39b1844",
  null
  
)

export default component.exports